import {
  groupPerformanceConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { groupPerformanceService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";

const { ALL_GROUP_RESPONSE_DATA, CUSTOMER_RESPONSES_EXPORT_ALL_DATA } =
  groupPerformanceConstants;

//Get all store responses
const getAllFranchiseResponses = (
  createDateFrom,
  createDateTo,
  groupId,
  body,
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_GROUP_RESPONSE_DATA, () =>
      groupPerformanceService
        .getAllFranchiseResponses(createDateFrom, createDateTo, groupId, body)
        .then(
          (response) => {
            dispatch(success(response, ALL_GROUP_RESPONSE_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

const getAllFranchiseResponsesItemsForExport = (
  createDateFrom,
  createDateTo,
  groupId,
  body,
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_GROUP_RESPONSE_DATA, () =>
      groupPerformanceService
        .getAllFranchiseResponses(createDateFrom, createDateTo, groupId, body)
        .then(
          (response) => {
            dispatch(
              success(
                response.pageData.result,
                CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
              ),
            );
          },
          (error) => {
            dispatch(resetAllExportItems());
            customToast(error[0], toastTypes.ERROR);
          },
        )
    );
  };
};

const resetAllExportItems = () => {
  return (dispatch) => {
    dispatch(failure([], CUSTOMER_RESPONSES_EXPORT_ALL_DATA));
  };
};

export const groupPerformanceActions = {
  getAllFranchiseResponses,
  getAllFranchiseResponsesItemsForExport,
  resetAllExportItems,
};
